import { FilteredCreditApplication, PHONE_NUMBER_IFINANCE, PHONE_NUMBER_LINK_IFINANCE, PageSectionTitle as SectionTitle } from '@applyonline/shared'
import { useEffect } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { trackEvent } from '../../../services/trackingEvents'
import { ETrackingEvent } from '../../../types/tracking'

interface Props {
  creditApp: FilteredCreditApplication
}

const DeclinedDecisionForm = ({ creditApp }: Props) => {
  const { t } = useTranslation()

  useEffect(() => {
    trackEvent(ETrackingEvent.QualifDeclined, creditApp)
  }, [creditApp])

  return (
    <main className="general-message" style={{ textAlign: 'center' }}>
      <SectionTitle title={t('common.financeApplication')} />
      <p>
        <Trans
          i18nKey="finalDecision.refused"
          values={{
            phoneNumber: PHONE_NUMBER_IFINANCE,
          }}
          components={{
            a: <Link to={PHONE_NUMBER_LINK_IFINANCE} style={{ textWrap: 'nowrap', textDecoration: 'underline' }} />,
          }}
        />
      </p>
    </main>
  )
}

export default DeclinedDecisionForm
